exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.question_drag_icon[data-v-52418ef6]:hover {\n  cursor: grab;\n}\n", ""]);

// exports
